const Modal = {
  baseStyle: {
    dialog: {
      borderRadius: "lg",
    },
  },
};

export default Modal;
